import {createAction} from 'redux-act';
import {IFamilyData, IFamilyMember, IFamilyMemberFileIdUpdate} from '@app-types/websocket/family.types';
import {IChildInfoUpdate} from '@app-types/websocket/sharedinfo.types';

interface ISignupCoparent {
  firstName: string;
  // lastName: string;
}

interface ISignupChild {
  firstName: string;
  date: string;
}


export const signupAddFamilyMember = createAction<ISignupCoparent>('Signup add family member');
export const signupAddChild = createAction<ISignupChild>('Signup add child');
export const addFamilyMember = createAction<IFamilyMember>('Add family member');
export const addUser = createAction<IFamilyMember>('Add user to family');
export const deleteFamilyMember = createAction<number>('Delete family member');
export const unlimitFamilyMember = createAction<number>('Unlimit family member');
export const restoreAccount = createAction<number>('Restore account');
export const nudgeToLogIn = createAction<number>('Nudge to log in');
export const updateFamilyMember = createAction<IFamilyMember>('Update family member');
export const updateFamilyMemberFileId = createAction<IFamilyMemberFileIdUpdate>('Update family member file Id');
export const createFamily = createAction<IFamilyData>('create new family');
export const selectCountry = createAction<string>('select country');
export const updateChildInfo = createAction<IChildInfoUpdate>('update child info');
export const enrichFamily = createAction('Enrich family data with color');
export const enrichFamilySuccess = createAction<IFamilyMember[]>('Save enriched family data');



// WEBPACK FOOTER //
// ./src/services/family/family.actions.ts